<template>
    <v-card class="px-4 py-2 mb-8">
      <div class="custom-field-mapping  my-2 d-flex">
        <h4 class="mr-1">Custom Field Mapping</h4>
        <v-tooltip
          top
          color="rgba(0, 0, 0, 0.9)"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
            >
              <v-icon size="20">
                mdi-information-outline
              </v-icon>
            </v-btn>
          </template>
          <span>Choose <span class="text-capitalize">{{ tooltipIntegrationName || integrationType }}</span> source fields to map with<br>
                Maropost Marketing Cloud target custom <br v-if="integrationType == 'keap'"> fields</span>
        </v-tooltip>
      </div>
        <v-row class="custom-width-row">
          <v-col>
            <div class="pb-3 font-weight-light">
              {{ sourceHeading }}
            </div>
            <v-divider class="pb-1" />
          </v-col>
          <v-col>
            <div class="pb-3 font-weight-light">
              {{ targetHeading }}
            </div>
            <v-divider class="pb-1" />
          </v-col>
        </v-row>
        <v-row
          v-for="(field, index) in mappedFieldsArr"
          :key="index"
          class="my-0"
        >
            <v-col class="py-0">
              <v-divider
                v-if="index > 0"
                class="pb-4"
              />
              <v-autocomplete
                :v-track="`${integrationType}-source-${index}`"
                v-model="field[integrationType]"
                :disabled="isReadOnly"
                label="Source"
                :items="sourceFields"
                :item-disabled="checkedSourceFields"
                no-data-text="No data available"
                item-text="name"
                item-value="name"
                outlined
                required
                item-color="#03B6FC"
                class="custom-selectbox custom-field-scroll"
                dense
                light
                :menu-props="{maxHeight:150}"
                :rules="field.maro ? [rules.required] : []"
              />
            </v-col>
            <v-col class="py-0">
              <v-divider
                v-if="index > 0"
                class="pb-4"
              />
              <v-autocomplete
                :v-track="`marketing-target-${field.maro}`"
                v-model="field.maro"
                label="Target"
                :disabled="!field[integrationType] || isReadOnly"
                :items="disabledCheckedMarketingFields(field[integrationType])"
                item-text="name"
                item-value="name"
                :search-input.sync="searchStrings[index]"
                outlined
                required
                class="custom-selectbox"
                item-color="#03B6FC"
                dense
                light
                no-data-text="No data available"
                @focus="loadFirstFieldPage"
                :menu-props="{maxHeight:150, offsetY: true, offsetOverflow: true,}"
                :rules="field[integrationType] ? [rules.required] : []"
              >
                <template #append-item>
                  <v-responsive
                    class="overflow-y-auto"
                    max-height="400"
                  >
                    <span v-intersect="loadNextFieldPage" />
                  </v-responsive>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1" :class="['title', index == 0 ? 'pt-1' : 'mt-2' ]">
              <v-icon  @click="removeMapping(index)">
                mdi-delete
              </v-icon>
            </v-col>
        </v-row>
      <div>
        <v-divider class="custom-width-divider"/>
      </div>
      <v-card-actions>
        <v-btn
          :v-track="'add-contact-import-custom-fields'"
          id="add-contact-import-custom-fields"
          class="pl-1"
          text
          @click="addCustomField"
          :disabled="isAddMoreDisabled"
        >
          <v-icon class="pr-1">
            mdi-plus
          </v-icon>
          ADD MORE
        </v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import { $fields } from "@/services";
import { isEmpty, cloneDeep } from "lodash";

  export default {
    name: 'IntegrationsCustomFieldMapping',
    props: [
      'items',
      'value',
      'sourceHeading',
      'targetHeading',
      'sourceFields',
      'payload',
      'integrationType',
      'isReadOnly',
      'mappingLimit',
      'tooltipIntegrationName'
    ],
    data () {
      return {
        searchMaroFields: '',
        fieldsCurrentPage: 1,
        marketingFields: [],
        mappedFieldsArr: this.$props.value,
        rules: {
          required: value => !!value || " Field is Required.",
        },
        searchStrings: {},
        selectedFieldType: ""
      }
    },
    async mounted () {
      await this.getMarketingCustomFields();
      this.mappedFieldsHash();
    },
    computed: {
      disabledCheckedMarketingFields () {
        return (source_field_name) => {
          let arr = []
          if (source_field_name != '') {
            const selectedField = this.sourceFields.filter(el => {
              return el.name == source_field_name
            })
            if (!isEmpty(selectedField)) {
              this.selectedFieldType = selectedField[0].type
              arr = this.marketingFields.filter((el) => {
                return el.field_type == selectedField[0].type
              })
              arr.forEach(item => item.disabled = false)
              arr.forEach(item => {
                this.mappedFieldsArr.forEach(el => {
                  if (el.maro == item.name) {
                    item.disabled = true
                  }
                })
              })
            }
          }
          return arr;
        }
      },
      isAddMoreDisabled(){
        return this.mappedFieldsArr.some(item => item.maro == '' || item[this.integrationType] == '')||
        this.isReadOnly || (this.mappingLimit && this.mappedFieldsArr.length == this.mappingLimit)
      }
    },
    methods: {
      getMarketingCustomFields (query = {}) {
        const params = {
          page: this.fieldsCurrentPage,
          per_page: 10,
          sort_order: 'asc',
          ...query,
        }
        $fields.fetch({ params }).then(res => {
          this.marketingFields = this.marketingFields.concat(res.data.data)
        })
      },
      /**
       * Lazy load maro fields
       */
      lazyLoadMaroFields() {
        const marketingFieldIndex = this.marketingFields.findIndex(field => {
          return field.name === this.searchMaroFields;
        })
        if (marketingFieldIndex === -1) {
          this.getMarketingCustomFields({ name: this.searchMaroFields, field_type: this.selectedFieldType })
        }
      },
      loadMappedFieldsonEdit() {
        const fields = this.$props.payload.mapped_fields
        if (!isEmpty(fields)) {
          this.mappedFieldsArr = []
          Object.keys(fields).forEach(key => {
            const marketingFieldIndex = this.marketingFields.findIndex(field => {
              return field.name === key
            })
            if (marketingFieldIndex === -1) {
              this.getMarketingCustomFields({ name: key })
            }
            let obj = { maro: key };
            obj[this.integrationType] = fields[key]
            this.mappedFieldsArr.push(obj);
          })
          this.mappedFieldsArr = cloneDeep(this.mappedFieldsArr)
        }
      },
      checkedSourceFields ({ name }) {
        return this.mappedFieldsArr.findIndex(val => val[this.integrationType] == name) > -1
      },
      loadFirstFieldPage(){
        this.fieldsCurrentPage = 1;
        this.getMarketingCustomFields({field_type: this.selectedFieldType});
      },
      /**
       * Load next page marketing data for list record
       */
      loadNextFieldPage () {
        this.fieldsCurrentPage++
        this.getMarketingCustomFields({field_type: this.selectedFieldType});
      },
      addCustomField () {
        const obj = { maro: '' }
        obj[this.integrationType] = ''
        this.mappedFieldsArr.push(obj)
      },
      mappedFieldsHash(){
        let payload = this.payload;
        payload.mapped_fields = {};
        this.mappedFieldsArr.forEach(field => {
          if(field.maro !== '' && field[this.integrationType] !== ''){
            payload.mapped_fields[field.maro] = field[this.integrationType];
          }
        });
        delete payload.mapped_fields[''];
        this.$emit('update-payload', payload);
      },
      removeMapping(itemIndex) {
       this.mappedFieldsArr = this.mappedFieldsArr.filter((item, index) => index != itemIndex )
      }
    },
    watch: {
      searchStrings: {
        handler(newVal) {
          Object.keys(newVal).forEach(key => {
            if(newVal[key] != null){
              this.fieldsCurrentPage = 1;
              this.searchMaroFields = newVal[key];
              this.lazyLoadMaroFields();
            }
          });
        },
        deep:true
      },
      mappedFieldsArr() {
        this.selectedFieldType = "";
        this.$emit('input', this.mappedFieldsArr)
      },
      payload() {
        this.loadMappedFieldsonEdit();
      }
    },
  }
</script>
<style scoped>
.custom-width-row{
  width: 95%;
}
.custom-width-divider{
  width: 91%;
}
</style>
